if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"fieldmanager","remotes":[],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(1(194|401|908)|2492|3547|3851|4629|5564|561|7050)$/.test(chunkId)},
		rootOutputDir: "../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}